import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-tag-selection',
	templateUrl: './modal-tag-selection.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalTagSelectionComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalTagSelectionComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.initialize();
		
		this.vm.selectTag = this.selectTag;
		this.vm.isTagSelected = this.isTagSelected;
		this.vm.close = this.close;
		this.vm.submit = this.submit;
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		this.vm.user = this.session.getSession().user;
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		
		this.vm.initialized = true;
	}
	
	selectTag(tag) {
		if (this.isTagSelected(tag)) {
			this.vm.selectedTags = this.vm.selectedTags.filter((item) => {
				return item.tag.id !== tag.tag.id;
			});
		} else {
			this.vm.selectedTags.push(tag);
		}
	}
	
	isTagSelected(tag) {
		var result: any = this.vm.selectedTags.filter((item) => {
			return item.tag.id === tag.tag.id;
		});
		return (result || []).length > 0;
	}
	
	submit() {
		this.dialogRef.close(this.vm.selectedTags);
	}
	
	close() {
		this.dialogRef.close(this.vm.selectedTags);
	}
	
}